export const InputCVV = ({
  error,
  cvvElementId
}: {
  error: spreedly.SpreedlyError['message'];
  cvvElementId: string;
}) => {
  return (
    <div className="co-flex co-w-full co-flex-col co-gap-[8px] co-h-fit">
      <LabelCVV htmlFor={cvvElementId} />
      <div className="co-flex co-flex-col co-gap-[4px] co-h-auto">
        <div className="co-w-full co-h-[48px]" id={cvvElementId}></div>
        {error && (
          <p
            className="co-px-[8px] co-text-[12px] co-leading-[16px] co-font-medium co-text-[#E90200]"
            id="cvv_error"
          >
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

const LabelCVV = ({ htmlFor }: { htmlFor: string }) => {
  return (
    <label
      className="co-flex co-w-fit co-text-[12px] co-font-semibold co-leading-[16px] co-text-[#363F45]"
      htmlFor={htmlFor}
    >
      CVV
    </label>
  );
};
